import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';

//containers
import AuthUserContainer from '../../containers/AuthUser';

//- UI / Form
import Grid from '@material-ui/core/Grid';
import SectionHeader from '../../components/SectionHeader';
import FormComponent from '../../components/FormComponent';
import { getGlobalClasses } from '../../themes';
import Note from '../../components/Note';
import GreenChecked from '../../images/icons/greenChecked.svg';
import { CircularProgress, Table, TableRow, TableCell, TableBody } from '@material-ui/core';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		deleteButton: {
			verticalAlign: 'middle',
			padding: '8px 10px',
		},
		addGroupButton: {
			borderRadius: '100px',
			fontSize: 16,
		},
		groupContainer: {
			borderLeft: '4px solid #ddd',
			marginLeft: 10,
			paddingLeft: 5,
			marginBottom: 20,
		},
		totalSection: {
			fontSize: 26,
			padding: 20,
			border: '1px solid #3faff5',
			margin: 10,
		},
		updateTotalSection: {
			fontSize: 20,
			border: '1px solid #3faff5',
			padding: 20,
			margin: 10,
		},
		addButton: {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			color: 'white',
			marginRight: 10,
			marginTop: 30,
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 60px',
			textTransform: 'uppercase',
		},
		cancelButton: {
			marginRight: 10,
			marginTop: 30,
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 60px',
			textTransform: 'uppercase',
		},
		currentStatus: {},
		statusRow: {
			padding: 7,
		},
		greenCheckedIcon: {
			display: 'inline-block',
			width: 20,
			height: 20,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 2,
			marginLeft: 5,
		},
	};
};

class ViewBody extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			dateAndHours: [
				{
					date: '',
					hours: '',
				},
			],
		};
	}

	renderStatus = () => {
		const { ptoRequest, classes, userMap } = this.props;

		if (!ptoRequest) {
			return;
		}
		const {
			status,
			requestedForUserId,
			assignedToSupervisorUserId,
			assignedToHrUserId,
		} = ptoRequest;

		const requestor = userMap[requestedForUserId] || { firstName: 'Unknown requested.' };
		const supervisor = userMap[assignedToSupervisorUserId] || { firstName: 'Not assigned yet.' };
		const hr = userMap[assignedToHrUserId] || { firstName: 'Not assigned yet.' };

		return (
			<Grid item xs={12}>
				<Note type="info">
					<div className={classes.statusRow}>
						<strong>Requested for:</strong> {requestor.firstName} {requestor.lastName}
					</div>
					<div className={classes.statusRow}>
						<strong>Assigned to Supervisor:</strong> {supervisor.firstName} {supervisor.lastName}
					</div>
					<div className={classes.statusRow}>
						<strong>Assigned to HR:</strong> {hr.firstName} {hr.lastName}
					</div>
					<div className={classes.statusRow}>
						<strong>Current Status:</strong> {_.startCase(status).replace('Hr ', 'HR ')}
					</div>
				</Note>
			</Grid>
		);
	};

	renderExistingPtoOnSchedule = () => {
		const {
			shouldShowPToScheduleSection,
			isFetchingWorkDays,
			searchForPtoShiftsApiResults,
			classes,
		} = this.props;

		if (!shouldShowPToScheduleSection) {
			return;
		}

		if (isFetchingWorkDays || !searchForPtoShiftsApiResults) {
			return (
				<Grid item xs={12}>
					<Note type="info">
						<CircularProgress style={{ height: 20, width: 20, paddingRight: 5 }} />
						Searching schedule for existing PTO requests...
					</Note>
				</Grid>
			);
		}

		const { usersLocationId, usersShiftId, collections } = searchForPtoShiftsApiResults;
		const workDays = collections?.workDayCollection;
		const userMap = _.keyBy(collections?.userCollection, 'userId');
		const locationMap = _.keyBy(collections?.locationCollection, 'locationId');
		const shiftMap = _.keyBy(collections?.shiftCollection, 'shiftId');

		const location = locationMap[usersLocationId] || { display: 'Missing' };
		const shift = shiftMap[usersShiftId] || { display: 'Missing' };

		if (_.isEmpty(workDays)) {
			return (
				<Grid item xs={12}>
					<Note type="info">
						<div>
							Searched the <strong>{location.display}</strong> location on the{' '}
							<strong>{shift.display}</strong> shift.
						</div>
						<div className={classes.greenCheckedIcon} />
						No drivers currently have scheduled PTO for the requested dates.
					</Note>
				</Grid>
			);
		}

		return (
			<Grid item xs={12}>
				<Note type="warn">
					<div>
						Searched the <strong>{location.display}</strong> location on the{' '}
						<strong>{shift.display}</strong> shift.
					</div>
					Found {workDays.length} days that already have a driver with scheduled PTO.
					<Table>
						<TableBody>
							{workDays.map((workDay) => {
								const user = userMap[workDay.userId] || { firstName: 'Missing', lastName: '' };
								return (
									<TableRow>
										<TableCell>{moment(workDay.date).format('MMM Do, YYYY')}</TableCell>
										<TableCell>
											{user.firstName} {user.lastName}
										</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</Note>
			</Grid>
		);
	};

	render() {
		const { classes, ptoRequest } = this.props;

		if (!ptoRequest) {
			return <div>Loading PTO request...</div>;
		}

		// figure out what state we are in
		//if (authUser.userId ===

		const { dateAndHours } = ptoRequest;
		let totalHours = 0;

		const ptoPaid = ptoRequest.paidType === 'ptoPaid';
		const ptoPaidSickPaid = ptoRequest.paidType === 'ptoPaidSickPaid';
		const ptoCashOut = ptoRequest.paidType === 'ptoCashOut';

		if (ptoCashOut) {
			totalHours = ptoRequest.ptoCashOutTotalHours;
		} else {
			for (const dateHour of dateAndHours) {
				const { hours } = dateHour;
				if (_.isNumber(parseInt(hours))) {
					totalHours += parseInt(hours);
				}
			}
		}

		return (
			<>
				<Grid item xs={12}>
					{this.renderStatus()}
				</Grid>
				<Grid item xs={12}>
					{this.renderExistingPtoOnSchedule()}
				</Grid>
				<SectionHeader label={'PAID TIME OFF TYPE'} gridProps={{ xs: 12 }} />

				<Grid item xs={12}>
					{ptoPaid && <div>✓ PTO Paid</div>}
					{ptoPaidSickPaid && <div>✓ PTO Paid Sick Pay</div>}
					{ptoCashOut && <div>✓ PTO Cash Out</div>}
				</Grid>

				{!ptoCashOut && (
					<>
						<SectionHeader label={'Requested Date and Hours'} gridProps={{ xs: 12 }} />
						<Grid item lg={10} md={12} xs={12}>
							{dateAndHours.map((row, index) => {
								const { date, hours } = row;
								return (
									<div key={index} style={{ padding: 3 }}>
										{moment(date).format('M/D/YYYY')} - {hours} hours
									</div>
								);
							})}
						</Grid>
					</>
				)}

				<Grid item xs={8}>
					<div style={{ display: 'flex' }} className={classes.updateTotalSection}>
						<>
							<div style={{ marginRight: 5 }}>
								<strong>Total Hours Requested: </strong>
							</div>
							{dateAndHours.length > 1 &&
								dateAndHours.map((dateAndHour, index) => {
									return (
										<div key={`addHour.${index}`}>
											{index !== 0 && <span style={{ padding: '0px 4px' }}>+</span>}{' '}
											{dateAndHour.hours}
										</div>
									);
								})}
							<div className={classes.total} style={{ marginLeft: 7 }}>
								{' '}
								= {totalHours} hours
							</div>
						</>
					</div>
				</Grid>

				<SectionHeader label={'Signed and Dated'} gridProps={{ xs: 12 }} />
				<Grid item md={8} xs={12}>
					Signed by: <strong>{ptoRequest.signatureName}</strong> on{' '}
					{moment(ptoRequest.signatureDate).format('M/D/YYYY')}
				</Grid>
			</>
		);
	}
}

ViewBody.propTypes = {
	ptoRequest: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
	ptoWorkDaysAlreadyOnSchedule: PropTypes.array,
	isFetchingWorkDays: PropTypes.bool,
	shouldShowPToScheduleSection: PropTypes.bool,
};

export default _.flow([withStyles(styles), AuthUserContainer])(ViewBody);
